/**
 * Aviso de "a sessão morreu de vez", do transporte para a UI.
 *
 * Vive aqui, e não junto do auth, para manter a regra de camada que o resto da
 * estrutura depende: `shared/` nunca importa `features/`. O client HTTP precisa
 * avisar alguém quando o proxy sinaliza `x-auth-expired`, mas não pode conhecer
 * a store de autenticação — então ele só publica o evento e quem se interessa
 * se registra (a store de auth, em features/auth).
 */

let onExpire: (() => void) | null = null;

/** Registra o callback de expiração (a store de auth conecta a UI aqui). */
export function setOnExpire(callback: () => void): void {
    onExpire = callback;
}

/** Avisa a UI de que a sessão morreu — chamado pelo http client num 401 real. */
export function notifySessionExpired(): void {
    onExpire?.();
}
